/**
 * @prettier
 */

import createBehavior from '@js/functions/createBehavior.js';

const seeMoreBehavior = createBehavior(
  'see-more',
  {
    bindUI() {
      this.ui = {}
      this.ui.moreBtn = this.getChild('button');
      this.ui.list = this.getChild('list');
    },
    bindEvents() {
      if (this.ui.moreBtn) {
        this.ui.moreBtn.addEventListener(
          'click',
          this.handleMoreBtnClick,
        );
      }
    },
    handleMoreBtnClick(evt) {
      evt.preventDefault();

      // find the first hidden item
      const items = this.ui.list.childNodes;
      const firstHiddenItem = Array.from(items).find(item => item.offsetParent === null);

      // show all
      this.node.classList.toggle('is-visible-full');

      if (!firstHiddenItem) {
        return;
      }

      // focus the first hidden item
      requestAnimationFrame(() => {
        const firstHiddenAction = firstHiddenItem.querySelector('a, button');
        if (firstHiddenAction) {
          firstHiddenAction.focus();
        } else {
          firstHiddenItem.setAttribute('tabindex', '-1');
          firstHiddenItem.focus();
        }
      });
    },
  },
  {
    init() {
      this.bindUI()
      this.bindEvents()
    },
    destroy() {},
  },
);

export default seeMoreBehavior;
